/** Filtre local par chargé de clientèle — instantané sans rechargement API. */
export const filterImpayesByCdc = (impayes, chargeFiltre) => {
  if (!chargeFiltre) {
    return impayes || [];
  }
  return (impayes || []).filter((row) => row.charge_de_clientele === chargeFiltre);
};
